import {combineReducers} from 'redux'
import location from './location'
import outlet from './outlet'
import environment from './environment'
import search from './search'
import accessory from './accessory'

export default combineReducers({
  location,
  outlet,
  environment,
  search,
  accessory
})



// WEBPACK FOOTER //
// ./src/store/reducers/index.js